import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { RestService } from 'src/app/services/rest.service';
import { Router } from '@angular/router';
import { AmDrawer } from '@angularminds/am-drawer';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnInit {
  // notification variables
  isNotificationsDrawerOpen: boolean = false;
  pageNo = 1;
  limit = 20;
  messages: any[] = [];
  totalCount: number;
  unreadCount: number;
  notificationCount: number;
  loading: boolean;

  constructor(
    private generalService: GeneralService,
    private restService: RestService,
    private router: Router,
    private amDrawer: AmDrawer,
  ) {}

  ngOnInit(): void {
    this.getNotifications();
  }

  /**
   * get notifications for user
   */
  getNotifications() {
    this.loading = true;
    this.generalService.getNotifications(this.pageNo, this.limit).subscribe((res: any) => {
      this.loading = false;
      this.messages = [...res.messages];
      this.unreadCount = res.unreadCount;
      this.totalCount = res.totalCount;
      this.generalService.setNotifications(res);
    });
  }

  /**
   * clear all notifications in drawer both(Read/Unread)
   */
  clearAll() {
    const data = {
      id: this.messages[0]._id,
    };
    this.restService.put(`/api/notifications/clear/all`, data).subscribe((res: any) => {
      this.getNotifications();
    });
  }

  /**
   * mark all notification as read
   */
  markAllAsRead() {
    const data = {
      status: 'Read',
    };
    this.restService.put(`/api/notifications/mark/all`, data).subscribe((res: any) => {
      this.getNotifications();
    });
  }

  /**
   * navigate when clicked on notification
   */
  redirectTo(notification: any) {
    if (notification.navigate.type.toLowerCase() === 'relative') {
      this.router.navigate([notification.navigate.url]);
      this.amDrawer.close();
    }
    // this.toggleNotificationsDrawerVisibility();
    this.markAsRead(notification._id);
  }

  /**
   * update notification status as Cleared for given id
   * @param id notification id to be updated
   */
  clearNotification(id: string) {
    const data = {
      status: 'Cleared',
    };
    this.updateNotification(id, data);
  }

  /**
   * mark notification status as Read for given id
   * @param id notification id to be updated
   */
  markAsRead(id: string) {
    const data = {
      status: 'Read',
    };
    this.updateNotification(id, data);
  }

  /**
   * load
   */
  loadMoreNotifications() {
    this.pageNo++;
    this.getNotifications();
  }

  /**
   * update notification status
   */
  updateNotification(id: string, data: any) {
    this.restService.put(`/api/notifications/${id}`, data).subscribe((res: any) => {
      this.getNotifications();
    });
  }

  close() {
    this.amDrawer.close();
  }

  trackByFn(index, item) {
    return item._id;
  }
}
